import { render, staticRenderFns } from "./OvpByJobTitleBaseForm.vue?vue&type=template&id=2d5148b7&"
import script from "./OvpByJobTitleBaseForm.vue?vue&type=script&lang=js&"
export * from "./OvpByJobTitleBaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports